import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DOGMA_GUIDES } from "@/data/dogmas";

export const DogmaPreviews = ({ prefix = "home", headingLevel = "h3" }) => {
  const Heading = headingLevel;
  return (
  <div className="grid gap-x-12 gap-y-10 md:grid-cols-2" data-testid={`${prefix}-dogma-grid`}>
    {DOGMA_GUIDES.map((dogma) => <article key={dogma.slug} className="min-w-0 border-t border-gold/40 pt-6" data-testid={`${prefix}-dogma-${dogma.slug}`}>
      <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-gold" data-testid={`${prefix}-dogma-date-${dogma.slug}`}>{dogma.number} · {dogma.date}</p>
      <Heading data-testid={`${prefix}-dogma-heading-${dogma.slug}`} className="mt-4 font-serif text-2xl font-semibold leading-tight text-midnight sm:text-3xl">
        <Link to={`/dogmas/${dogma.slug}`} data-testid={`${prefix}-dogma-link-${dogma.slug}`} className="group inline-flex max-w-full items-start gap-3 transition-colors hover:text-marian">
          <span className="min-w-0 break-words">{dogma.title}</span><ArrowUpRight className="mt-1 h-5 w-5 shrink-0 text-gold transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </Link>
      </Heading>
      <p className="mt-3 font-serif text-lg italic text-marian" data-testid={`${prefix}-dogma-subtitle-${dogma.slug}`}>{dogma.subtitle}</p>
      <p className="mt-4 text-sm leading-relaxed text-charcoal/85 sm:text-base" data-testid={`${prefix}-dogma-significance-${dogma.slug}`}>{dogma.summary}</p>
      <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.1em] text-slateblue">{dogma.ccc}</p>
    </article>)}
  </div>
  );
};